import React from 'react';
import {
    Box,
    Text,
    Image,
    Flex,
    useDisclosure,
    IconButton,
} from "@chakra-ui/react";
import { DeleteIcon, CheckIcon } from "@chakra-ui/icons";
import { ModalBox } from '../ModalBox';
import { fileSize } from '../../utils/helper';

export const ImageCard = ({ image, onDelete, isHideDelete = false, isSelection = false, selectMedia, mediaUrl }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleModalOpen = () => {
        onOpen();
    };
    const url = !Array.isArray(mediaUrl) ? [mediaUrl] : mediaUrl
    const size = fileSize(image)
    return (
        <>
            <Box
                key={image.id}
                bg="white"
                boxShadow="md"
                borderRadius="lg"
                overflow="hidden"
                position="relative"
                _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
                backgroundColor={url.includes(image.url) ? "blue.200" : "white"}
                onClick={isSelection ? () => selectMedia("images", image.url, image) : handleModalOpen}
            >
                {/* Image */}
                <Box
                    h="150px"
                    bg="gray.100"
                    overflow="hidden"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Image
                        src={image.url}
                        alt={image.name}
                        objectFit="cover"
                        w="100%"
                        h="100%"
                        cursor="pointer"
                        loading="lazy"
                    />
                </Box>

                {/* Details */}
                <Box p={2}>
                    <Text fontWeight="bold" isTruncated>
                        {image.name}
                    </Text>
                    <Flex justify="space-between" mt={2} align="center">
                        <Text fontSize="sm" color="gray.500">
                            {size}
                        </Text>
                        {
                            !isHideDelete ?
                                <IconButton
                                    aria-label="Delete"
                                    icon={<DeleteIcon />}
                                    size="sm"
                                    variant="ghost"
                                    colorScheme="red"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete(image.id)
                                    }}
                                /> : 
                                <>
                                    {
                                        url.includes(image.url) ?
                                        <CheckIcon color="blue.500" /> : <></>
                                    }
                                </>
                        }
                    </Flex>
                </Box>
            </Box>
            <ModalBox
                title={image.name}
                description={
                    <Image loading="lazy" src={image?.url} alt={image?.key} maxW="100%" />
                }
                isOpen={isOpen}
                onClose={onClose}
                isFooter={false}
            />
        </>
    );
}
